import Select from '../../../../../ui/Select';

const NavigationForMob = ({ categorys, onCategoryChange, category }) => {
  return (
    <Select
      options={categorys}
      value={category}
      onChange={onCategoryChange}
      placeholder={'What’s New'}
      className="md:hidden flex max-w-[344px] w-full relative z-50 mx-auto"
    />
  );
};

export default NavigationForMob;
